<template>
  <div>
    <section class="principal">
      <h3>Cadastro Portal API - Fluxo Alternativo</h3>
      <hr class="divider">
      <div class="filtro-situacao">
        <div>
          <label class="label-filtro"> Filtrar por Situação: </label>
          <select v-model="filtroSituacao" class="form-select"> 
              <option value="PLD">PLD</option>
              <option value="BUP">BUP</option>
              <option value="FIN">FIN</option>
              <option value="REC">REC</option>
          </select>
        </div>
        <div>
          <button @click="carregarDados" class="carregarDados">
            <i class="fa fa-search"></i> Pesquisar</button>
        </div>
      </div>
      <template v-if="dados.length">
        <ul class="lista-ordenada">
          <li v-for="item in itensFiltrados" :key="item.keyJira" id="caixa">
            <span>{{ valorPadrao(item.keyJira) }}</span>
            <span class="span-li">{{ valorPadrao(item.nome) }}</span>
            <span>{{ valorPadrao(item.situacao) }}</span>
            <button v-if="item.situacao === 'PLD'" @click="avancarPLD(item.keyJira)" class="btn-carregarDados"> Avançar </button>
            <button v-if="item.situacao === 'BUP'" @click="avancarBUP(item.keyJira)" class="btn-carregarDados"> Avançar </button>
            <button v-if="item.situacao === 'FIN'" :class="{ 'btn-disabled': item.situacao === 'FIN' }" class="btn-secondary"> Sem Ação </button>
            <button v-if="item.situacao === 'REC'" :class="{ 'btn-disabled': item.situacao === 'REC' }" class="btn-secondary"> Sem Ação </button>
          </li>
        </ul>
      </template>
      <div class="loader">
        <div>
          <div class="spinner-border"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import * as ajaxUtils from '@/utils/ajax';

export default {
  data() {
    return {
      dados: [],
      filtroSituacao: '',
    };
  },
  computed: {
    itensFiltrados() {
      return this.filtroSituacao? this.dados.filter(item => item.situacao === this.filtroSituacao) : this.dados;
    },
  },
  methods: {
    async carregarDados() {
      this.dados = await ajaxUtils.get(`/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/jira/listar`, true);
    },
    valorPadrao(valor) {
      return valor === null || valor === undefined? 'N/A' : valor;
    },
    async avancarPLD(idPreCadastroOperadoraApi) {
      await ajaxUtils.getOK(`/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/jira/avancar-pld/${idPreCadastroOperadoraApi}`, 'Jira avançado com sucesso!');
      this.carregarDados();
    },
    async avancarBUP(idPreCadastroOperadoraApi) {
      await ajaxUtils.getOK(`/massificados/corporativo/gerenciador-parceiros/rest/pre-cadastro-operadora-api/jira/avancar-bup/${idPreCadastroOperadoraApi}`, 'Jira avançado com sucesso!');
      this.carregarDados();
    }
  }
};
</script>

<style scoped>
@import '/massificados/corporativo/gerenciador-parceiros-ui/fluxo-alternativo/css/style.css';
</style>